var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"file",attrs:{"type":"file","name":"profile_avatar","accept":".png, .jpg, .jpeg"},on:{"change":_vm.handleFileUpload}}),_c('b-modal',{attrs:{"id":"modal-lg","title":"برش دادن","ok-title":"ذخیره","cancel-title":"لغو"},on:{"ok":_vm.Crop}},[_c('cropper',{ref:"cropper",staticClass:"cropper",attrs:{"src":_vm.image,"stencil-props":{
		aspectRatio: 12/12
	}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }